import axios from 'axios';
import { adminMainUrl } from '../../../Config';

//unused final Quotation with Pagination List
export const getLedgerAccountDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_LEDGER_DETAIL_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/ledger-account/${id}`;

        try {
            axios.get(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_LEDGER_DETAIL_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getLedgerAccountDetail function (redux):", err);
                dispatch({
                    type: "FIND_LEDGER_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getLedgerAccountDetail function:", error);
            dispatch({
                type: "FIND_LEDGER_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//view job order details
export const getJobOrderAccountExpenseDetails = (token, user_id, job_order_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_JOB_ORDER_ACCOUNT_EXPENSE_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/view-job-order`;

        let body = {
            job_order_id: job_order_id
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_JOB_ORDER_ACCOUNT_EXPENSE_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                let errmsg = "Internal server error";
                if (err && err.response && err.response.data && err.response.data.msg) {
                    errmsg = err.response.data.msg
                }
                console.log("ERROR in getJobOrderAccountExpenseDetails function (redux):", err, errmsg);
                dispatch({
                    type: "FIND_JOB_ORDER_ACCOUNT_EXPENSE_FAILURE",
                    payload: errmsg,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderAccountExpenseDetails function:", error);
            let errmsg = "Internal server error.";
            if (error && error.message) {
                errmsg = error.message
            }
            dispatch({
                type: "FIND_JOB_ORDER_ACCOUNT_EXPENSE_FAILURE",
                payload: errmsg,
            });
        }
    };
};

//view expense details
export const getExpenseDetails = (token, user_id, expense_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_EXPENSE_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/view-expense`;

        let body = {
            expense_id: expense_id
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_EXPENSE_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                let errmsg = "Internal server error";
                if (err && err.response && err.response.data && err.response.data.msg) {
                    errmsg = err.response.data.msg
                }
                console.log("ERROR in getExpenseDetails function (redux):", err, errmsg);
                dispatch({
                    type: "FIND_EXPENSE_FAILURE",
                    payload: errmsg,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getExpenseDetails function:", error);
            let errmsg = "Internal server error.";
            if (error && error.message) {
                errmsg = error.message
            }
            dispatch({
                type: "FIND_EXPENSE_FAILURE",
                payload: errmsg,
            });
        }
    };
};

//view expense remarks
export const getExpenseRemarks = (token, user_id, expense_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_EXPENSE_REMARKS_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/get-remarks`;

        let body = {
            expense_id: expense_id
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_EXPENSE_REMARKS_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                let errmsg = "Internal server error";
                if (err && err.response && err.response.data && err.response.data.msg) {
                    errmsg = err.response.data.msg
                }
                console.log("ERROR in getExpenseRemarks function (redux):", err, errmsg);
                dispatch({
                    type: "FIND_EXPENSE_REMARKS_FAILURE",
                    payload: errmsg,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getExpenseRemarks function:", error);
            let errmsg = "Internal server error.";
            if (error && error.message) {
                errmsg = error.message
            }
            dispatch({
                type: "FIND_EXPENSE_REMARKS_FAILURE",
                payload: errmsg,
            });
        }
    };
};